import { AlkLogger } from '@alk/core';
import { IGridScrollData, IGridScrollService } from './grid-scroll.interface';
import { injectable } from 'inversify';
import { Observable, Subject } from 'rxjs';

@injectable()
export class GridScrollMock implements IGridScrollService {
    next(data: IGridScrollData) {
        AlkLogger.info('[GridScrollMock] next()', data);
    }

    asObservable(): Observable<IGridScrollData> {
        return (new Subject<IGridScrollData>()).asObservable();
    }
}
